/**
 * Bootstrap environment + logging utilities
 *
 * Exposes shared helpers used by bootstrap modules to:
 * - Gate logs in development only (keep production console clean)
 * - Detect Capacitor/native platforms to conditionally run native code
 */

import { Capacitor } from '@capacitor/core';

/** True when running a Vite dev build. */
export const DEV = Boolean((import.meta as any)?.env?.DEV);

/** Console.log only in dev. */
export const devLog = (...args: unknown[]) => {
  if (DEV) console.log(...args);
};

/** Console.warn only in dev. */
export const devWarn = (...args: unknown[]) => {
  if (DEV) console.warn(...args);
};

/** True inside a native Capacitor runtime (Android/iOS), false on the web. */
export const isNative = Capacitor.getPlatform() !== 'web';
/** True on Android (Capacitor platform). */
export const isAndroid = Capacitor.getPlatform() === 'android';

// Platform-specific flags removed from styling paths; keep only generic flag.
